'use client';

import React from 'react';

export default function YandexReviewsIframeSkeleton() {
  return (
    <div
      className="w-full lg:w-1/2 flex-shrink-0"
      style={{
        height: '700px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div className="h-full w-full rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-200 dark:bg-gray-700 animate-pulse" />
    </div>
  );
}


